import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import MobileAdhesion from '@wix/da-ads/pkg/adunits/MobileAdhesion';
import DesktopAdhesion from '@wix/da-ads/pkg/adunits/DesktopAdhesion';
import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import { useSelector } from 'react-redux';
import { getCurrentAdSafety } from '@wix/da-shared-react/pkg/Ads/redux/selectors';

const AdhesionAd: React.FC<{}> = () => {
  const isMobile = useContext(MobileContext);
  const { adsEnabled } = useContext(SessionContext);
  const ads_nitro = useFlag('ads_nitro');
  const location = useLocation();
  const adSafety = useSelector(state => getCurrentAdSafety(state));

  if (!location.pathname.match(/\/(gallery|favourites)/)) {
    return null;
  }

  if (isMobile && adsEnabled && ads_nitro) {
    return (
      <ErrorBoundary debugComponent="MobileAdhesion">
        <MobileAdhesion safety={adSafety!} />
      </ErrorBoundary>
    );
  }

  if (adsEnabled && ads_nitro) {
    return (
      <ErrorBoundary debugComponent="DesktopAdhesion">
        <DesktopAdhesion safety={adSafety!} />
      </ErrorBoundary>
    );
  }

  return null;
};
AdhesionAd.displayName = 'AdhesionAd';

export default AdhesionAd;
